import PropTypes from 'prop-types';
import './Cards.scss';

function Cards({
  className = '',
  children,
}) {
  return (
    <div className={`Cards ${className}`}>
      {children}
    </div>
  );
}

Cards.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Cards;
